import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Panel from 'components/Panel';
import Button, { BlueButton } from 'components/Button';
import {
  SubPanel,
  SubPanelRow,
  PanelRowDescriptor,
  PanelRowDisplay,
  StyledForm,
  FullPanel,
  PanelContent,
  PanelButtonRow,
  PanelRowTextForm
} from 'components/PanelComponents';
import Text from 'components/Text';
import { useDispatch, useSelector } from 'react-redux';
import { revertSidePanel, closeSidePanel } from 'reducers/sidePanel/actions';
import DeleteModal from 'components/Modals/DeleteModal';
import { deleteAggregator, editAggregator } from 'reducers/aggregator/actions';

const WhiteButton = styled(Button)`
  background: #ffffff;
  border: 2px solid #0779af;
  p {
    font-size: 12px;
    color: #0779af;
  }
`;

const EditAggregator = ({ isActive }) => {
  const dispatch = useDispatch();
  const id = useSelector(state => state.sidePanel.id);
  const aggregators = useSelector(state => state.aggregator.aggregators);
  const [isLoading, setIsLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState('');
  const [registrationPin, setRegistrationPin] = useState('');
  const [registrationPinIsError, setRegistrationPinIsError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const aggregator = aggregators.find(
      aggregator => aggregator.aggregatorId === id
    );
    setIsLoading(false);
    setRegistrationPin(aggregator?.registrationPin || '');
  }, [aggregators, id]);

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'registrationPin') setRegistrationPin(value);
  };

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal);
  };

  const handleDelete = async () => {
    try {
      setShowDeleteModal(false);
      await dispatch(deleteAggregator(id));
      dispatch(closeSidePanel());
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async e => {
    try {
      e.preventDefault();

      const parsedAsIntRegistrationPin = parseInt(registrationPin);

      let passed = true;
      if (
        registrationPin &&
        (!/^\d+$/.test(registrationPin) ||
          isNaN(parsedAsIntRegistrationPin) ||
          parsedAsIntRegistrationPin > 999999 ||
          parsedAsIntRegistrationPin < 0)
      ) {
        setRegistrationPinIsError(true);
        passed = false;
      } else {
        setRegistrationPinIsError(false);
      }

      if (!passed) {
        return;
      }

      let requestBody = {};
      if (parseInt(registrationPin) >= 0) {
        requestBody = { registrationPin: parseInt(registrationPin) };
      }
      await dispatch(editAggregator(requestBody, id));
      dispatch(revertSidePanel());
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isActive || (isActive && isLoading)) {
    return null;
  } else {
    return (
      <>
        <StyledForm onSubmit={handleSubmit}>
          <FullPanel>
            <Panel title="Selected Aggregator Info » Edit" primaryHeader />
            <PanelContent>
              <SubPanel>
                <SubPanelRow>
                  <PanelRowDescriptor>
                    <Text fontSize="12px">ID</Text>
                  </PanelRowDescriptor>
                  <PanelRowDisplay>
                    <Text fontSize="12px">{id}</Text>
                  </PanelRowDisplay>
                </SubPanelRow>

                <SubPanelRow>
                  <PanelRowDescriptor>Registration Pin</PanelRowDescriptor>
                  <PanelRowTextForm
                    type="number"
                    name="registrationPin"
                    onChange={handleInputChange}
                    isError={registrationPinIsError}
                    value={registrationPin}
                    min="0"
                    max="999999"
                    step="1"
                  />
                </SubPanelRow>

                <SubPanelRow>
                  <PanelRowDescriptor>
                    <Text fontSize="12px">Delete This Aggregator</Text>
                  </PanelRowDescriptor>
                  <WhiteButton
                    type="button"
                    onClick={() => toggleDeleteModal()}
                  >
                    Delete Aggregator
                  </WhiteButton>
                </SubPanelRow>
              </SubPanel>
            </PanelContent>
            <PanelButtonRow>
              <WhiteButton
                type="button"
                onClick={() => dispatch(revertSidePanel())}
              >
                Cancel
              </WhiteButton>
              <BlueButton type="submit">Edit Aggregator</BlueButton>
            </PanelButtonRow>
          </FullPanel>
        </StyledForm>
        {showDeleteModal ? (
          <DeleteModal
            toggleDeleteModal={toggleDeleteModal}
            handleDelete={handleDelete}
          />
        ) : null}
      </>
    );
  }
};

export default EditAggregator;
